<template>
  <div :class="b()">
    <template v-if="data.length">
      <div
        v-if="headings"
        :class="b('head')"
      >
        <div
          v-if="showedLineNumber"
          :class="b('head-item', { number: true }, [
            headings.classes && headings.classes.headItem,
            headings.classes && headings.classes.number,
          ].join(' '))"
        >
          <slot name="head-item-number">
            {{ headings.number }}
          </slot>
        </div>

        <div
          v-for="columnName in columns"
          :key="`head-${columnName}`"
          :class="b('head-item', [
            headings.classes && headings.classes.headItem,
            headings.classes && headings.classes[columnName],
          ].join(' '))"
        >
          <slot :name="`head-item-${columnName}`">
            {{ headings[columnName] }}
          </slot>
        </div>
      </div>

      <div :class="b('list')">
        <div
          v-for="(row, index) in data"
          :key="index"
          :class="b('row')"
        >
          <div
            v-if="showedLineNumber"
            :class="b('row-item', { number: true }, [
              row.classes && row.classes.rowItem,
              row.classes && row.classes.number,
            ].join(' '))"
          >
            {{ index + 1 }}
          </div>

          <div
            v-for="columnName in columns"
            :key="columnName"
            :class="b('row-item dark', [
              row.classes && row.classes.rowItem,
              row.classes && row.classes[columnName],
            ].join(' '))"
          >
            <slot
              :name="`row-item-${columnName}`"
              v-bind="row"
            >
              {{ row[columnName] }}
            </slot>
          </div>
        </div>
      </div>
    </template>

    <div
      v-else
      :class="b('empty-message')"
    >
      {{ emptyMessage }}
    </div>
  </div>
</template>

<script>
  /**
   * @TODO: refactor! избавиться от bem модуля
   */

  export default {
    name: 'BaseTable',
    props: {
      columns: {
        type: Array,
        required: true,
      },
      headings: {
        type: Object,
        default: null,
      },
      data: {
        type: Array,
        default: null,
      },
      showedLineNumber: {
        type: Boolean,
        default: false,
      },
      emptyMessage: {
        type: String,
        default: 'Данных нет...',
      },
    },
  };
</script>

<style lang="scss">
  .base-table {
    overflow-x: auto;
    font-weight: 400;
    font-variant-numeric: lining-nums tabular-nums;
    font-family: $fontFamilyInter;
    &__head {
      display: flex;
      @include typography(17px, 20px);
      color: black;
      opacity: 0.4;
    }

    &__row {
      display: flex;
      padding-top: 10px;
      padding-left: 15px;
      padding-bottom: 10px;
      @include typography(17px, 20px);
    }
    &__row:nth-child(even) {
      background-color: #f2f2f2;
    }

    &__row-item,
    &__head-item {
      white-space: nowrap;
      flex-shrink: 0;
      box-sizing: border-box;

      &:last-child {
        border-right: 0;
        padding-right: 0;
      }

      &_number {
        width: 25px;
        text-align: center;

        @include media('xs') {
          padding-right: 10px;
        }

        @include mediaMin('sm') {
          padding-right: 20px;
        }
      }
    }

    &__empty-message {
      color: $colorGrayDark;
      text-align: center;
    }
  }
</style>
